import { Box, Link, Typography } from '@material-ui/core'
import { PropsWithChildren } from 'react'
import { useTheme } from 'styled-components'

export interface IFooterLegalLinkProps {
  addDotSeparator?: boolean
  onClick?: (ev) => void
  to?: string
}

export const FooterLegalLink = ({ addDotSeparator, onClick, children, to }: PropsWithChildren<IFooterLegalLinkProps>) => {
  const theme = useTheme()

  return (
    <>
      <Typography variant="caption">
        <Box color={theme.colors.accent} textAlign="end" fontWeight="bold" display="flex" onClick={onClick}>
          <Link href={to} target="_blank">
            <Box color={theme.colors.accent}>{children}</Box>
          </Link>
          {addDotSeparator && <Box margin="0 1em">&#8226;</Box>}
        </Box>
      </Typography>
    </>
  )
}
